import {inject, injectable} from 'inversify';

import {CachedMediaFactory} from '../CachedMedia/CachedMedia.factory';
import {AudioModel} from './Audio.model';
import {BaseAudioModel} from './BaseAudio.model';

@injectable()
export class AudioModelFactory {
  constructor(
    @inject(CachedMediaFactory)
    private readonly cachedMediaFactory: CachedMediaFactory,
  ) {}

  create(props: BaseAudioModel.Props) {
    return new AudioModel(props, this.cachedMediaFactory);
  }
}
